// src/components/UnderConstructionGate.jsx
import React, {useEffect} from "react";
import {Alert, Button, Card} from "antd";
import {ToolOutlined} from "@ant-design/icons";
import {useNavigate} from "react-router-dom";

function SkeletonLine({w = "w-full"}) {
  return <div className={`h-3 ${w} rounded bg-neutral-200/80`} />;
}

function SkeletonBox() {
    useEffect(() => {
    document.title = "USDSeller | В разработке";
  }, []);
  return (
    <div className="space-y-4">
      <div className="rounded-xl border border-neutral-200 bg-white p-4 shadow-sm">
        <div className="flex items-center gap-3">
          <div className="h-9 w-9 rounded-full bg-neutral-200/80" />
          <div className="flex-1 space-y-2">
            <SkeletonLine w="w-1/2" />
            <SkeletonLine w="w-2/3" />
          </div>
        </div>
        <div className="mt-4 space-y-2">
          <SkeletonLine />
          <SkeletonLine w="w-11/12" />
          <SkeletonLine w="w-9/12" />
        </div>
      </div>

      <div className="rounded-xl border border-neutral-200 bg-white p-4 shadow-sm">
        <div className="flex items-center justify-between">
          <SkeletonLine w="w-1/3" />
          <SkeletonLine w="w-24" />
        </div>
        <div className="mt-4 space-y-3">
          <div className="grid grid-cols-3 gap-3">
            <div className="h-10 rounded bg-neutral-200/80" />
            <div className="h-10 rounded bg-neutral-200/80" />
            <div className="h-10 rounded bg-neutral-200/80" />
          </div>
          <div className="space-y-2">
            <div className="h-9 rounded bg-neutral-200/80" />
            <div className="h-9 rounded bg-neutral-200/80" />
            <div className="h-9 rounded bg-neutral-200/80" />
            <div className="h-9 rounded bg-neutral-200/80" />
          </div>
        </div>
      </div>

      <div className="rounded-xl border border-neutral-200 bg-white p-4 shadow-sm">
        <div className="flex items-center justify-between">
          <SkeletonLine w="w-2/5" />
          <SkeletonLine w="w-28" />
        </div>
        <div className="mt-4 grid grid-cols-2 gap-3">
          <div className="h-20 rounded bg-neutral-200/80" />
          <div className="h-20 rounded bg-neutral-200/80" />
        </div>
      </div>
    </div>
  );
}

export default function UnderConstructionGate({
  enabled = true,
  title = "Страница в разработке",
  description = "Этот раздел временно недоступен. Мы скоро его закончим.",
  backTo, // optional: "/"
  ctaText = "Назад",
  showCta = true,
}) {
  const navigate = useNavigate();

  if (!enabled) return null;

  const onClick = () => {
    if (backTo) navigate(backTo);
    else navigate(-1);
  };

  return (
    <div className="relative">
      {/* Fake blurred content */}
      <div className="pointer-events-none select-none blur-[2px]">
        <div className="mx-auto w-full max-w-[1100px] p-4 sm:p-6">
          <SkeletonBox  />
        </div>
      </div>

      {/* Overlay */}
      <div className="absolute inset-0 z-10 flex items-center justify-center p-4">
        <Card className="w-full max-w-[520px] shadow-sm">
          <Alert
            type="warning"
            showIcon
            icon={<ToolOutlined />}
            message={<span className="font-semibold">{title}</span>}
            description={<div className="text-neutral-700">{description}</div>}
          />
          {showCta && (
            <div className="mt-4 flex justify-end">
              <Button type="primary" onClick={onClick}>
                {ctaText}
              </Button>
            </div>
          )}
        </Card>
      </div>
    </div>
  );
}